import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  coupons: null,
  loading: false,
  couponBtnLoading: false,
  deleteBtnLoading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.COUPON_CONTROLS:
      return updateObject(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
